import ClearableTextField from './clearableTextField';

export default ClearableTextField;